import React from 'react';
import {
  useLocation,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import UserBasicDetails from './UserBasicDetails';
import { ArrowBack } from '@material-ui/icons';
// import userReportDetails from './userReportDetails';
import UserReportDetails from './userReportDetails';
import UserEvaluationDetails from './UserEvaluationDetails';

const ShowAbcatDetails = ({ userDetails, report, evaluation }) => {
  // You can fetch or receive these props via location.state, Redux, or API as needed
  const location = useLocation();
  const history = useHistory();
  userDetails = userDetails || location.state?.userParams || {};
  console.log(userDetails, 'user');

  return (
    <div className='p-6'>
      <div className='flex gap-2 items-center mb-6'>
        <ArrowBack
          className='cursor-pointer'
          onClick={() => {
            history.goBack();
          }}
        />
        <h1 className='text-2xl font-semibold'>Student AB-CAT Details</h1>
      </div>

      <UserBasicDetails userDetails={userDetails?.User} />
      <UserReportDetails report={userDetails?.report} />
      <UserEvaluationDetails evaluation={userDetails?.abCatEvaluation} />
    </div>
  );
};

export default ShowAbcatDetails;
